module.exports = __webpack_public_path__ + "app/components/smart-grid-1qQ955Uk.html";